import { css } from '@emotion/react';

export default function InputHeightContainer({
  children,
  hasMsgReceiverPicker,
}: {
  children?: React.ReactNode;
  hasMsgReceiverPicker?: boolean;
}) {
  return (
    <div
      css={css`
        min-height: ${hasMsgReceiverPicker ? '100px' : '61px'};
      `}
    >
      {children}
    </div>
  );
}
